export default function ViewRooms() {
  const units = [
    {
      id: 1,
      name: "Room A101",
      price: "₱7,000 / month",
      image: "/images/assets/room_1.jpg",
    },
    {
      id: 2,
      name: "Room A102",
      price: "₱7,200 / month",
      image: "/images/assets/room_2.jpg",
    },
    {
      id: 3,
      name: "Room B201",
      price: "₱7,500 / month",
      image: "/images/assets/room_3.jpg",
    },
  ]

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-8">
        {/* TITLE */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900">Available Units</h2>
          <p className="text-slate-600 mt-2">
            Choose a room that fits your lifestyle and budget.
          </p>
        </div>

        {/* GRID */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
          {units.map((unit) => (
            <div
              key={unit.id}
              className="bg-white rounded-xl overflow-hidden shadow hover:shadow-xl transition"
            >
              {/* IMAGE */}
              <img
                src={unit.image}
                alt={unit.name}
                className="h-48 w-full object-cover"
              />

              {/* CONTENT */}
              <div className="p-5">
                <h3 className="text-lg font-semibold text-slate-900">
                  {unit.name}
                </h3>

                <p className="text-orange-500 font-bold mt-1">{unit.price}</p>

                <button className="mt-4 w-full bg-orange-500 text-white py-2 rounded-md font-semibold hover:bg-orange-600">
                  Inquire Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
